import ManagementRegime from './ManagementRegime'

export default ManagementRegime
